<template>
  <div class="IntroVideo" @click="close">
    <div class="x-close" @click="close">x</div>
    <div class="frame">
      <video class="iframe" controls autoplay frameborder="0">
        <source :src="url" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
export default {
  props: ["url"],
  data() {
    return {     
    };
  },

  methods: {
    close() {            
      this.$emit("close", false);
    }
  }
};
</script>

<style scoped>
.IntroVideo {
  background: rgba(0, 0, 0, 0.85);
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.IntroVideo .frame {
  /* background: #fcfcfc; */
  width: 100%;
  height: 438px;
  top: 33%;
  left: 0;
  position: absolute;
  /* border: 15px solid #ccc; */
  /* border-radius: 20px; */
}
.IntroVideo .frame  .iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 418px;
  object-fit: cover;
}
.x-close {
  font-size: 38px;
  width: 38px;
  height: 38px;
  right: 18px;
  top: 22px;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  line-height: 38px;
  position: absolute;
  text-align: center;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/video/CourseVideo.vue